import * as API from "./Api";
const CHAT_URL = `${process.env.REACT_APP_API_CHAT_URL}`;

export const getChatList = ({ page, limit, search, type }) =>
  API.get(
    `/chat/list/${type}?page=${page}&limit=${limit}&search=${search || ""}`,
    null,
    null,
    CHAT_URL
  );

export const joinChat = (data) => API.post("/chat/join", data, null, CHAT_URL);

export const getChatMessages = (chatId, page, limit) =>
  API.get(`/chat/${chatId}?page=${page}&limit=${limit}`, null, null, CHAT_URL);
